export default "__VITE_ASSET__D9UlUeIu__"